import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import RouteService from '../../../services/RouteService';
import HelperNavigation from '../../common/HelperNavigation';
import globalTranslations from '../../../i18n/globalTranslations';
import Paths from '../../../types/Paths';
import MainOrderList from '../../order/MainOrderList';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import { modelOf } from '../../../prop-types';
import RecurringOrderStore from '../../../store/RecurringOrderStore';

const ORDER_COUNT_PER_PAGE = 10;

@observer
export class MyAccountRecurringOrderList extends Component {
  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccount
      },
      {
        text: intl.formatMessage(globalTranslations.recurringOrdersTitle),
        url: Paths.MyAccountRecurringOrderList
      }
    ]);
  };

  render() {
    return (
      <Fragment>
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <div className="MyAccountRecurringOrderList">
          <SEOTitle title={globalTranslations.recurringOrdersTitle} />
          <PageTitle>
            <FormattedMessage {...globalTranslations.recurringOrdersTitle} />
          </PageTitle>
          <div className="MyAccountRecurringOrderList__description">
            <div className="MainOrderList__description">
              <FormattedMessage {...globalTranslations.readAboutRecurring} />
            </div>
            <FormattedMessage
              id="recurringOrder.paymentCardReminder"
              defaultMessage="Subscriptions will be charged from a payment card. Please make sure you have added valid payment card. You can have multiple payment cards."
            />
          </div>
          <MainOrderList
            resultsPerPage={ORDER_COUNT_PER_PAGE}
            useRecurringOrders={true}
          />
        </div>
      </Fragment>
    );
  }
}

MyAccountRecurringOrderList.propTypes = {
  recurringOrderStore: modelOf(RecurringOrderStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(
  inject('routeService', 'recurringOrderStore')(MyAccountRecurringOrderList)
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountRecurringOrderList/index.jsx